/**
 * @ngdoc directive
 * @name reassurance
 *
 * @description
 * Reassurance
 */
module.directive('reassurance', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            sections: '=content'
        },
        template:
                '<div class="aqua-reassurance">' +

                '  <div class="grid-main">' +
                '    <div class="grid grid-gutter-large">' +

                '      <div class="aqua-reassurance--item grid-4 grid-12-s" ng-repeat="section in sections">' +
                '        <h3 class="aqua-reassurance--title">{{section.title}}</h3>' +
                '        <div class="aqua-reassurance--description" ng-bind-html="section.content | trustAsHtml"></div>' +
                '      </div>' +

                '    </div>' +
                '  </div>' +
                '</div>'
    };
});